var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.4,5.1V0.6h-5.2c-1.2,0-2.2,1-2.2,2.2v13.3c0,1.2,1,2.2,2.2,2.2h8.9c1.2,0,2.2-1,2.2-2.2V6.6H20 C19.1,6.6,18.4,5.9,18.4,5.1z M19.9,0.6V5h4.4L19.9,0.6z M9.5,16.9V6.6H2.9c-1.2,0-2.2,1-2.2,2.2v13.3c0,1.2,1,2.2,2.2,2.2h8.9 c1.2,0,2.2-1,2.2-2.2v-2.2h-1.5C10.9,19.9,9.5,18.6,9.5,16.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.f6b624c6226eda3f01b6c45b61c1cdde.svg";
export { ForwardRef as ReactComponent };